__turbopack_context__.v({
  "activeMap": "ResultsOutputMaps-module-scss-module__V8qw_W__activeMap",
  "hoveredCountry": "ResultsOutputMaps-module-scss-module__V8qw_W__hoveredCountry",
  "map": "ResultsOutputMaps-module-scss-module__V8qw_W__map",
  "mapWrapper": "ResultsOutputMaps-module-scss-module__V8qw_W__mapWrapper",
  "mapsContainer": "ResultsOutputMaps-module-scss-module__V8qw_W__mapsContainer",
  "mapsTrack": "ResultsOutputMaps-module-scss-module__V8qw_W__mapsTrack",
  "nextMap": "ResultsOutputMaps-module-scss-module__V8qw_W__nextMap",
  "prevMap": "ResultsOutputMaps-module-scss-module__V8qw_W__prevMap",
});
